import { React, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import "./styles.css";

function Permisos() {
  const [banners, setBanners] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const getBanners = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/permissions`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        }
      );
      console.log("====================================");
      console.log(res.data);
      console.log("====================================");
      if (res.data.code === 1) {
        setBanners(res.data.permissions);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  let optionsUsers = [];

  const createPermission = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        }
      );
      if (res.data.code === 1) {
        optionsUsers = res.data.users
          .map(
            (user) =>
              `<option key=${user.email} value=${user.email}>${user.email}</option>`
          )
          .join("");
      }

      const result = await Swal.fire({
        title: "Agregar Permisos",
        html:
          '<div class="form-grid text-start">' +
          "<select id='c_user'>" +
          "<option value=''>Elija usuario</option>" +
          optionsUsers +
          "</select><br><br>" +
          '<div class="modal-permissions-container">' +
          '<div class="modal-section-permissions">' +
          "<label>Permisos Dashboard: </label><br><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='1'> Usuario</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='2'> Permisos</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='3'> Banners</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='4'> Textos</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='5'> Contactos Web</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='6'> Tarifario Nacional</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='7'> Cotizaciónes</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='8'> Códigos postales</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='9'> Estaciones</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='10'> Servicios</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='11'> Pdf logger</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='12'> Estaciones Internacionales</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='24'> Cambio de turno</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='25'> Reporte de login</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='26'> Kpi Personal</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='27'> Turnos Carga Ligera</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='37'> Turnos Carga Pesada</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='38'> Turnos Recollección</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='28'> Mostradores</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='35'> Buscadores</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='36'> Preguntas Frecuentes</label><br>" +
          "</div>" +
          '<div class="modal-section-permissions">' +
          "<label>Carga ligera: </label><br><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='13'> Cliente</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='14'> Pesador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='15'> Documentador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='16'> Pantalla de turnos Principal</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='44'> Pantalla de turnos Secundaria</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='17'> Inspector</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='39'> Reimpresion de Turnos</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='40'> Turnos</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='42'> Administrador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='47'> KPI Usuarios</label><br>" +
          "</div>" +
          '<div class="modal-section-permissions">' +
          "<label>Carga pesada: </label><br><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='19'> Cliente</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='20'> Pesador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='21'> Documentador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='22'> Pantalla de turnos Principal</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='46'> Pantalla de turnos Secundaria</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='23'> Inspector</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='41'> Reimpresion de Turno</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='43'> Turnos</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='45'> Administrador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='48'> KPI Usuarios</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='49'> Acciones Administrador</label><br>" +
          "</div>" +
          '<div class="modal-section-permissions">' +
          "<label>Recolección: </label><br><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='29'> Cliente</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='30'> Documentador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='31'> Buscador</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='32'> Salidas</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='33'> Pantalla Turnos</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='34'> Inspector</label><br>" +
          "<label><input name='c_permissions[]' type='checkbox' value='50'> Pantalla Busquedas</label><br>" +
          "</div>" +
          "</div>" +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Agregar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          const email = document.getElementById("c_user").value;
          if (email === "") {
            Swal.showValidationMessage("Debes seleccionar un correo");
            return false;
          }

          const checkboxes = document.querySelectorAll(
            'input[name="c_permissions[]"]:checked'
          );
          const checkedValues = Array.from(checkboxes).map(
            (checkbox) => checkbox.value
          );

          return new Promise(function (resolve) {
            resolve({
              permissions: checkedValues,
              user: email,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const userData = result.value;
        if (userData.permissions.length === 0) {
          Swal.fire("Error", "No se agrego ningun permiso.", "error");

          return;
        }

        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/permissions/create`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        Swal.fire("¡Exito!", "Se le asignaron permisos al usuario.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      if (error.response.data.code === 0) {
        Swal.fire("Error al asignar permisos", "Revisar información.", "error");
      } else {
        Swal.fire("Error al asignar permisos", "Revisar información", "error");
      }
    }
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const deletePermission = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/api/permissions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );

        Swal.fire(
          "¡Eliminado!",
          "El/los permisos ha(n) sido eliminado.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "error");
      }
    } catch (error) {
      console.error("Error al Eliminar el usuario:", error);
    }
  };

  const updatePermission = async (id) => {
    try {
      // Obtener los datos del usuario a editar del servidor
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/permissions/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
          },
        }
      );
      let permissionData = response.data.permission.permissions;

      const result = await Swal.fire({
        title: "Editar Banner",
        html:
          '<div class="form-grid text-start">' +
          '<div class="modal-permissions-container">' +
          '<div class="modal-section-permissions">' +
          "<label>Permisos Dashboard: </label><br><br>" +
          `<label><input name='c_permissions[]' type='checkbox' value='1' ${
            permissionData.includes("1") ? "checked" : ""
          }> Usuario</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='2' ${
            permissionData.includes("2") ? "checked" : ""
          }> Permisos</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='3' ${
            permissionData.includes("3") ? "checked" : ""
          }> Banners</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='4' ${
            permissionData.includes("4") ? "checked" : ""
          }> Textos</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='5' ${
            permissionData.includes("5") ? "checked" : ""
          }> Contactos Web</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='6' ${
            permissionData.includes("6") ? "checked" : ""
          }> Tarifario Nacional</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='7' ${
            permissionData.includes("7") ? "checked" : ""
          }> Cotizaciónes</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='8' ${
            permissionData.includes("8") ? "checked" : ""
          }> Códigos postales</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='9' ${
            permissionData.includes("9") ? "checked" : ""
          }> Estaciones</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='10' ${
            permissionData.includes("10") ? "checked" : ""
          }> Servicios</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='11' ${
            permissionData.includes("11") ? "checked" : ""
          }> Pdf logger</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='12' ${
            permissionData.includes("12") ? "checked" : ""
          }> Estaciones Internacionales</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='24' ${
            permissionData.includes("24") ? "checked" : ""
          }> Cambio de turno</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='25' ${
            permissionData.includes("25") ? "checked" : ""
          }> Reporte de login</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='26' ${
            permissionData.includes("26") ? "checked" : ""
          }> Kpi Personal</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='27' ${
            permissionData.includes("27") ? "checked" : ""
          }> Turnos Carga Ligera</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='37' ${
            permissionData.includes("37") ? "checked" : ""
          }> Turnos Carga Pesada</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='38' ${
            permissionData.includes("38") ? "checked" : ""
          }> Turnos Recolección</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='28' ${
            permissionData.includes("28") ? "checked" : ""
          }> Mostradores</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='35' ${
            permissionData.includes("35") ? "checked" : ""
          }> Buscadores</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='36' ${
            permissionData.includes("36") ? "checked" : ""
          }> Preguntas Frecuentes</label><br>` +
          "</div>" +
          '<div class="modal-section-permissions">' +
          "<label>Permisos Carga ligera: </label><br><br>" +
          `<label><input name='c_permissions[]' type='checkbox' value='13' ${
            permissionData.includes("13") ? "checked" : ""
          }> Cliente</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='14' ${
            permissionData.includes("14") ? "checked" : ""
          }> Pesador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='15' ${
            permissionData.includes("15") ? "checked" : ""
          }> Documentador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='16' ${
            permissionData.includes("16") ? "checked" : ""
          }> Pantalla turnos Principal</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='44' ${
            permissionData.includes("44") ? "checked" : ""
          }> Pantalla turnos Secundaria</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='17' ${
            permissionData.includes("17") ? "checked" : ""
          }> Inspector</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='39' ${
            permissionData.includes("39") ? "checked" : ""
          }> Reimpresion de Turnos</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='40' ${
            permissionData.includes("40") ? "checked" : ""
          }> Turnos</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='42' ${
            permissionData.includes("42") ? "checked" : ""
          }> Administrador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='47' ${
            permissionData.includes("47") ? "checked" : ""
          }> KPI Usuarios</label><br>` +
          "</div>" +
          '<div class="modal-section-permissions">' +
          "<label>Permisos Carga pesada: </label><br><br>" +
          `<label><input name='c_permissions[]' type='checkbox' value='19' ${
            permissionData.includes("19") ? "checked" : ""
          }> Cliente</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='20' ${
            permissionData.includes("20") ? "checked" : ""
          }> Pesador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='21' ${
            permissionData.includes("21") ? "checked" : ""
          }> Documentador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='22' ${
            permissionData.includes("22") ? "checked" : ""
          }> Pantalla turnos Principal</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='46' ${
            permissionData.includes("46") ? "checked" : ""
          }> Pantalla turnos Secundaria</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='23' ${
            permissionData.includes("23") ? "checked" : ""
          }> Inspector</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='41' ${
            permissionData.includes("41") ? "checked" : ""
          }> Reimpresion de Turno</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='43' ${
            permissionData.includes("43") ? "checked" : ""
          }> Turnos</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='45' ${
            permissionData.includes("45") ? "checked" : ""
          }> Administrador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='48' ${
            permissionData.includes("48") ? "checked" : ""
          }> KPI Usuarios</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='49' ${
            permissionData.includes("49") ? "checked" : ""
          }> Acciones administrador</label><br>` +
          "</div>" +
          '<div class="modal-section-permissions">' +
          "<label>Permisos Recolección: </label><br><br>" +
          `<label><input name='c_permissions[]' type='checkbox' value='29' ${
            permissionData.includes("29") ? "checked" : ""
          }> Cliente</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='30' ${
            permissionData.includes("30") ? "checked" : ""
          }> Documentador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='31' ${
            permissionData.includes("31") ? "checked" : ""
          }> Buscador</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='32' ${
            permissionData.includes("32") ? "checked" : ""
          }> Salidas</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='33' ${
            permissionData.includes("33") ? "checked" : ""
          }> Pantalla Turnos</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='34' ${
            permissionData.includes("34") ? "checked" : ""
          }> Inspector</label><br>` +
          `<label><input name='c_permissions[]' type='checkbox' value='50' ${
            permissionData.includes("50") ? "checked" : ""
          }> Pantalla Busquedas</label><br>` +
          "</div>" +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          const checkboxes = document.querySelectorAll(
            'input[name="c_permissions[]"]:checked'
          );
          const checkedValues = Array.from(checkboxes).map(
            (checkbox) => checkbox.value
          );
          return new Promise(function (resolve) {
            resolve({
              permissions: checkedValues,
              user: id,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;
        // Realizar la solicitud PUT al servidor para actualizar el usuario
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/permissions/update`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
              "Content-Type": "application/json",
            },
          }
        );

        Swal.fire(
          "¡Actualizado!",
          "Los permisos han sido actualizados exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error al actualizar usuario:", error);
    }
  };

  const filteredUsers = searchValue
    ? banners.filter(
        (banner) =>
          banner.user &&
          banner.user.toUpperCase().includes(searchValue.toUpperCase())
      )
    : banners;

  useEffect(() => {
    getBanners();
  }, [updateTrigger]);

  return (
    <>
      <div className="table-responsive">
        <div className="panel-table">
          <div className="colum-left">
            <input
              type="text"
              className="searchInput"
              id="searchInput"
              placeholder="Buscar..."
            />
            <button className="btnn" onClick={handleSearch}>
              Buscar
            </button>
          </div>
          <div className="colum-rigth">
            <button className="btnn" onClick={createPermission}>
              Agregar Permisos
            </button>
          </div>
        </div>
        <table className="table table-preve" id="tableToSearch">
          <thead>
            <tr>
              <th>Usuario</th>
              <td className="accions">Acciones</td>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td>Cargando</td>
              </tr>
            ) : (
              filteredUsers.map((banner) => (
                <tr key={banner.user} data-master-id={banner.user}>
                  <td>{banner.user}</td>
                  <td>
                    <FaEdit
                      className="editButton"
                      onClick={() => {
                        updatePermission(banner.user);
                      }}
                    />
                    <FaTimes
                      className="deleteButton"
                      onClick={() => {
                        deletePermission(banner.user);
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default Permisos;
